<template>
  <b-modal v-model="show" size="lg" centered header-bg-variant="primary" hide-footer title="Create Scratch Card Setting" @hide="cancelModal()">
    <template v-if="show">
      <b-row>
        <b-col sm="6">
          <p-input v-model="form.name" label="Name" name="name" :handler="$v" :formData="form" type="text"/>
        </b-col>
        <b-col sm="3">
          <p-input v-model="form.cardWidth" label="Card Width" name="cardWidth" :handler="$v" :formData="form" type="text" helptext="Specify in px"/>
        </b-col>
        <b-col sm="3">
          <p-input v-model="form.cardHeight" label="Card Height" name="cardHeight" :handler="$v" :formData="form" type="text" helptext="Specify in px"/>
        </b-col>
        <b-col sm="4">
          <p-input v-model="form.price" label="Card Price" name="price" :handler="$v" :formData="form" type="text"/>
        </b-col>
        <b-col sm="4">
          <p-input v-model="form.dailyPayoutLimit" label="Daily Payout Limit" name="dailyPayoutLimit" :handler="$v" :formData="form" type="text"/>
        </b-col>
        <b-col sm="2">
          <p-dropdown v-model="form.type" label="Price Type" name="type" :handler="$v" :formData="form" :options="priceTypeList" textKey="key" textValue="label"/>
        </b-col>
        <b-col sm="2">
          <p-switch v-model="form.status" label="Status" name="status" :handler="$v" :formData="form"/>
        </b-col>
        <b-col sm="6">
          <p-input v-model="form.bannerUrl" label="Background Image" name="bannerUrl" :handler="$v" :formData="form" type="text"/>
          <div class="image-wrapper" :style="{ width: '220px', height: (form.cardHeight/form.cardWidth)*220 + 'px'}">
            <img :src="form.bannerUrl" alt="Background Image" width="100%" v-if="form.bannerUrl !== ''">
          </div>
        </b-col>
        <b-col sm="6">
          <p-input v-model="form.coverUrl" label="Cover Image" name="coverUrl" :handler="$v" :formData="form" type="text"/>
          <div class="image-wrapper" :style="{ width: '220px', height: (form.cardHeight/form.cardWidth)*220 + 'px'}">
            <img :src="form.coverUrl" alt="Cover Image" width="100%" v-if="form.coverUrl !== ''">
          </div>
        </b-col>
        <b-col sm="12">
          <p-input v-model="form.description" label="Description" name="description" :handler="$v" :formData="form" type="editor" :rows="10"/>
        </b-col>
        <b-col sm="12">
          <b-button variant="success" @click="save()">Save</b-button>
          <b-button variant="outline-danger" @click="cancelModal()">Cancel</b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import { Events } from '../../../events.js'
import VueNotifications from 'vue-notifications'
import { required, numeric } from 'vuelidate/lib/validators'
import { PInput, PSwitch, PDropdown } from '../../../components'

export default {
  name: 'scratchcard-settings-update',
  props: {
    priceTypeList: {
      type: Array,
      default: []
    },
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: {
        name: '',
        cardWidth: '',
        cardHeight: '',
        description: '',
        bannerUrl: '',
        coverUrl: '',
        type: null,
        price: '',
        dailyPayoutLimit: 0,
        status: 1,
        errorMessages: {
          name: {
            required: 'Scratch Card Name is required.'
          },
          cardHeight: {
            required: 'Please set card height',
            numeric: 'Must be number'
          },
          cardWidth: {
            required: 'Please set card width',
            numeric: 'Must be number'
          },
          description: {
            required: 'Descript is required'
          },
          bannerUrl: {
            required: 'Please set background url'
          },
          coverUrl: {
            required: 'Please set cover url'
          },
          type: {
            required: 'Please select Price Type'
          },
          price: {
            required: 'Scratch Card Price is required',
            numeric: 'Must be number'
          },
          dailyPayoutLimit: {
            required: 'Daily Payout Limit is required',
            numeric: 'Must be number'
          },
          status: {
            required: 'Status is required'
          }
        }
      }
    }
  },
  validations: {
    form: {
      name: { required },
      cardWidth: { required, numeric },
      cardHeight: { required, numeric },
      description: { required },
      type: { required },
      price: { required, numeric },
      dailyPayoutLimit: { required, numeric },
      bannerUrl: { required },
      coverUrl: { required },
      status: { required }
    }
  },
  components: {
    PInput,
    PSwitch,
    PDropdown
  },
  computed: {
    show: {
      get: function () {
        return this.showModal
      },
      set: function () {
        return this.showModal
      }
    }
  },
  methods: {
    async save () {
      try {
        Events.$emit('loader')
        this.$v.form.$touch()
        if (this.$v.form.$error) {
          return
        }
        await this.$http.post(this.API_ENDPOINT + '/scratchcard/game/create', {
          name: this.form.name,
          description: this.form.description,
          cardWidth: this.form.cardWidth,
          cardHeight: this.form.cardHeight,
          bannerUrl: this.form.bannerUrl,
          coverUrl: this.form.coverUrl,
          type: this.form.type,
          dailyPayoutLimit: this.form.dailyPayoutLimit,
          price: this.form.price,
          status: this.form.status
        }, { headers: { 'Content-Type': 'application/json' } })
        Events.$emit('alert', VueNotifications.types.success, 'Success', 'CreateUpdate Successful')
        this.cancelModal()
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    cancelModal () {
      this.form.name = ''
      this.form.cardWidth = ''
      this.form.cardHeight = ''
      this.form.description = ''
      this.form.bannerUrl = ''
      this.form.coverUrl = ''
      this.form.type = null
      this.form.price = ''
      this.form.dailyPayoutLimit = ''
      this.form.status = 1
      this.$emit('closeModal')
      this.$v.form.$reset()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/scratchcard/settings/AddSettings.vue